<header class="edocs">
    <div class="wrapper px-3">
        <div class="keep left">
            <a href="//{{resolvedSubdomain}}es.gov.br/internal" target="_blank" matTooltip="Acessar a página inicial do E-Docs">
                <img class="edocs-logo" alt="E-Docs" src="https://cdn.e-docs.es.gov.br/img/logo-edocs/e-docs-logo-transparent-small.png" />
            </a>
            <span class="eflow-title">E-Flow</span>
        </div>

        <div class="keep right">
            <img class="app-logo" alt="E-Flow" src="/assets/img/logo_eflow_reduzido.png" />
        </div>
    </div>
</header>
